import { Text } from "@meditect/medibase-components";

export const SalesCannotCloseSaleWithNegativeRealMoneyError = () => {
  return (
    <Text>
      Les règlements encaissés (espèces, mobile, carte, chèque) totalisent un montant négatif : une remise, un crédit ou
      une part sécurité sociale dépasse ce que le client doit. Corrigez les règlements avant de clôturer.
    </Text>
  );
};
